const allStepTypes = [
  { text: 'Accommodation', value: 'accommodation', icon: 'mdi-hotel' },
  { text: 'Adventure', value: 'adventure', icon: 'mdi-image-filter-hdr' },
  { text: 'Drink', value: 'drink', icon: 'mdi-glass-cocktail' },
  { text: 'Event', value: 'event', icon: 'mdi-ticket' },
  { text: 'Flight', value: 'flight', icon: 'mdi-airplane' },
  { text: 'Food', value: 'food', icon: 'mdi-silverware-fork-knife' },
  { text: 'Museum', value: 'museum', icon: 'mdi-bank' }
]

function getStepIcon (step) {
  const s = allStepTypes.find(x => x.value === step.type)
  return s ? s.icon : null
}

export {
  allStepTypes,
  getStepIcon
}
